<template>
  <div class="warp" style="background-color:#fff;min-height:1400px;">
    <div class="info" style="height:44px;text-align:center;padding:0 15px">
      <a-row>
        <a-col>
          <a-icon type="left" style="float:left;line-height:44px;" />
        </a-col>
        <a-col>
          <div style="text-align:center;line-height:44px">
            订单详情
          </div>
        </a-col>
      </a-row>
      <div style="color:coral;">
        <span style="float:left;">待支付</span><span style="float:right;">剩余00时28分30秒</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CurriculaVariavle',
  description: '选课',
  // 初始化变量
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus">

</style>
